import React from 'react';

const CarsonFooter = () => {
    return (
        <div className={'CarsonFooter'}>
            <div>Carson Animal Care Center</div>
            <div>216 W Victoria St.</div>
            <div>Gardena, CA 90248</div>
            <div>(310) 523-9566</div>
        </div>
    );
};

export default CarsonFooter;
